import React from 'react';
import { List } from 'semantic-ui-react'
import {flowRight as compose} from 'lodash';
import general from '../../../modulos/general';
import {graphql} from 'react-apollo';

//utils
import queries from '../../../utils/queries'

import TitDer from '../../../components/funcionales/titder';
var moment = require('moment');

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => { 
  let colorCelda='white'
  if(elemento.venceFact){
    let fechaHoy = new Date()
    fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    fechaHoy=moment(fechaHoy)
    var fecFin=moment(elemento.venceFact).format('YYYY-MM-DD')
    let numDias= fechaHoy.diff(fecFin, 'days') 
    if(numDias>0){
      colorCelda = 'red'
    }
  }

  return (
    <tr className=''>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.descrEmpresa}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.ordenCompraCliente?elemento.ordenCompraCliente:''}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numOrdenCompra}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numAvance}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.fechaSolic?elemento.fechaSolic.substr(0, 10):""}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.usuarioSolic}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorFact?new Intl.NumberFormat('de-DE').format(elemento.valorFact):0}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: colorCelda}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.numFactura}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.venceFact?elemento.venceFact.substr(0, 10):""}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorPagado?new Intl.NumberFormat('de-DE').format(elemento.valorPagado):0}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.totalOC?new Intl.NumberFormat('de-DE').format(elemento.totalOC):0}</td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          href={'images/cotizaciones/' + elemento.archivoFactura}
            target="_blank">
          {elemento.archivoFactura}
        </a>
      </td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          href={'images/cotizaciones/' + elemento.archivoRecibido}
            target="_blank">
          {elemento.archivoRecibido}
        </a>
      </td>
      <td className='' style={{color: 'black', background: '#FFFFFF'}}>
        <a style={{color: 'black'}}
          href={'images/cotizaciones/' + elemento.archivoEnviado}
            target="_blank">
          {elemento.archivoEnviado}
        </a>
      </td>
    </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class AdminPagosCli2 extends React.Component { 
  state = {argsBuscCad: {}, 
    argsQuery: `{$match: {tipoCoti: 'Cliente'}},
    {"$unwind": "$itemsFactura"},
      {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
      archivoEnviado: 1, archivoRecibido: 1, ordenCompraCliente: 1,
      estadoOC: 1, valorFact: '$itemsFactura.valorFact', 
      valorPagado: {
        $let: {
            vars: {valorPago: '$itemsFactura.valorPagado'},
            in: { $cond: { if: { $eq: [ "$$valorPago", null ] }, then: 0, else: "$$valorPago" } }
        }
    },
        numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
        venceFact: '$itemsFactura.venceFact', archivoFactura: '$itemsFactura.archivoFactura',
        usuarioSolic: '$itemsFactura.usuarioSolic', fechaSolic: '$itemsFactura.fechaSolic', usuarioFact: '$itemsFactura.usuarioFact',
        fechaFact: '$itemsFactura.fechaFact', fechaPago: '$itemsFactura.fechaPago', usuarioPago: '$itemsFactura.usuarioPago'}},
      {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
      estadoOC: 1, valorFact: 1, valorPagado: 1, numAvance: 1, numFactura: 1, venceFact: 1, ordenCompraCliente: 1,
      archivoEnviado: 1, archivoRecibido: 1, archivoFactura: 1, 
      usuarioSolic: 1, fechaSolic: 1, usuarioFact: 1, fechaFact: 1, fechaPago: 1, usuarioPago: 1,
      totalOC: {
        $let: {
            vars: {valorFact: {$toInt: '$valorFact'}, valorPagado: {$toInt: '$valorPagado'}},
            in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
        }
      }
      }},
      {$match: {numFactura: {$ne: ""}, totalOC: {$gt: 0}}}, 

      {$sort: {numFactura: 1}}`
  }

  async componentDidUpdate (prevProps){
    if(this.props.argsBuscCad!==prevProps.argsBuscCad){
      let argsBuscar = `'tipoCoti': 'Cliente'`
      if(this.props.argsBuscCad.descrEmpresa){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscCad.descrEmpresa}/i`
      }          
      if(this.props.argsBuscCad.numFactura){
        argsBuscar += `, 'numFactura': /${this.props.argsBuscCad.numFactura}/i`
      }
      if(this.props.argsBuscCad.numOrdenCompra){
        argsBuscar += `, 'numOrdenCompra': /${this.props.argsBuscCad.numOrdenCompra}/i`
      }
      if(this.props.argsBuscCad.ordenCompraCliente){
        argsBuscar += `, 'ordenCompraCliente': /${this.props.argsBuscCad.ordenCompraCliente}/i`
      }
    
      let argsBuscCad = `{$match: {${argsBuscar}}}`
      let argsBuscarIt = {tipoqry: `[${this.state.argsQuery}, ${argsBuscCad}]`}
      await this.props.allCotizacionRtesPagos.refetch(argsBuscarIt)
    }
  }
  
  render(){
console.log(this.props.list)
    let list = []
    if(this.props.allCotizacionRtesPagos.allCotizacionRtes){list = this.props.allCotizacionRtesPagos.allCotizacionRtes}
    return (
      <div>
        <List selection>
          <TitDer list={this.props.list} textBoton1="Registrar pagos de clientes" btnNuevo={"NO"} styles={this.props.styles}/>
          
          <div style={{height: '35em', overflow: 'auto'}}>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''>
                  {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Tipo</th> */}
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Cliente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>No. Orden compra cliente</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>No. Orden de compra LCM</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>No. Avance</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Fecha solic.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Usuario Solic.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Valor fact.</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>No. Factura</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Fecha vencimiento factura</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Vlr pagado</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Saldo</th>
                  {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Estado OC</th> */}
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Archivo factura</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Archivo Orden de compra</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Archivo cotización</th>
                </tr>
              </thead>
              <Lista list={list} handleClickidLista={this.props.handleClickidLista}/>
            </table>
            <p></p>
          </div>
        </List>

      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtesPagos',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente'}},
    {"$unwind": "$itemsFactura"},
      {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
      archivoEnviado: 1, archivoRecibido: 1, ordenCompraCliente: 1,
      estadoOC: 1, valorFact: '$itemsFactura.valorFact', 
      valorPagado: {
        $let: {
            vars: {valorPago: '$itemsFactura.valorPagado'},
            in: { $cond: { if: { $eq: [ "$$valorPago", null ] }, then: 0, else: "$$valorPago" } }
        }
    },
        numAvance: {"$toString": "$itemsFactura.numAvance"}, numFactura: '$itemsFactura.numFactura', 
        venceFact: '$itemsFactura.venceFact', archivoFactura: '$itemsFactura.archivoFactura',
        usuarioSolic: '$itemsFactura.usuarioSolic', fechaSolic: '$itemsFactura.fechaSolic', usuarioFact: '$itemsFactura.usuarioFact',
        fechaFact: '$itemsFactura.fechaFact', fechaPago: '$itemsFactura.fechaPago', usuarioPago: '$itemsFactura.usuarioPago'}},
      {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, numOrdenCompra: 1, numCoti: 1, tipo: 1, tipoCoti: 1, descrEmpresa: 1, 
      estadoOC: 1, valorFact: 1, valorPagado: 1, numAvance: 1, numFactura: 1, venceFact: 1, ordenCompraCliente: 1,
      archivoEnviado: 1, archivoRecibido: 1, archivoFactura: 1, 
      usuarioSolic: 1, fechaSolic: 1, usuarioFact: 1, fechaFact: 1, fechaPago: 1, usuarioPago: 1,
      totalOC: {
        $let: {
            vars: {valorFact: {$toInt: '$valorFact'}, valorPagado: {$toInt: '$valorPagado'}},
            in: { $subtract: [ "$$valorFact", "$$valorPagado" ] }
        }
      }
      }},
      {$match: {numFactura: {$ne: ""}, totalOC: {$gt: 0}}}, 

      {$sort: {numFactura: 1}}
    ]`}}}}),

)(AdminPagosCli2) 
